
import Component from "vue-class-component";
import Vue from "vue";
import {
    AddVtsCenterPracticeRequest,
    PracticesClient,
    VtsCenterPracticeActions,
    VtsCenterPracticeDetailsModel,
    IAddVtsCenterPracticeRequest,
    factory
} from "@/api-client";
import VtsCenterPracticeUpsertForm from "@/features/documents/practices/components/VtsCenterPracticeUpsertForm.vue";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";
import {Prop} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";
import {Location} from "vue-router";

interface Props {
    seafarerId: string;
    actions: VtsCenterPracticeActions;
    existingPractice: VtsCenterPracticeDetailsModel;
}

@Component({
    components: {
        FormLayout,
        VtsCenterPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditVtsCenterPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const practiceId = to.params.id;
        Promise.all([
            new PracticesClient().availableVtsCenterActions(),
            new PracticesClient().getVtsCenterPractice(practiceId),
        ]).then(values => {
            props.actions = values[0];
            props.existingPractice = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditVtsCenterPractice extends Vue implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: VtsCenterPracticeActions;

    @Prop({required: true})
    existingPractice!: VtsCenterPracticeDetailsModel;

    @Prop({default: null})
    returnRoute!: Location | null;

    model: AddVtsCenterPracticeRequest = factory.create(AddVtsCenterPracticeRequest);
    isCreated = false;

    created() {
        this.model = new AddVtsCenterPracticeRequest({
            ...this.existingPractice,
            existingFiles: this.existingPractice.files || [],
            addedFiles: [],
            removedFiles: []
        } as IAddVtsCenterPracticeRequest);
        this.isCreated = true;
    }

    async submit(model: AddVtsCenterPracticeRequest): Promise<void> {
        const practiceId = this.$route.params.id;
        await new PracticesClient().edit(model, this.seafarerId, practiceId);

        // Navigate back to the context where the edit was initiated
        const route = (this.returnRoute ? this.returnRoute : { name: "seafarer-practices" }) as Location;
        route.params = { seafarerId: this.seafarerId};
        this.$router.replace(route);
    }
}
